import { Permission } from '@/enums/Permission';
export interface MenuItem {
  id: string;
  nameKey: string;     // Translation key
  icon: string;
  path?: string;
  permissions?: string[];
  external?: boolean;
}

export interface MenuGroup {
  id: string;
  nameKey: string;     // Translation key for the group header
  items: MenuItem[];
}

export const menuGroups: MenuGroup[] = [
  {
    id: 'core',
    nameKey: 'Core', // You can add translation for 'Core' or omit the header
    items: [
      {
        id: Permission.DASHBOARD,
        nameKey: Permission.DASHBOARD,
        icon: 'fas fa-chart-bar',
        path: '/app/dashboard',
      }
    ]
  },
  {
    id: 'sales',
    nameKey: 'Sales',
    items: [
      {
        id: 'sales',
        nameKey: 'Sales',
        icon: 'fas fa-shopping-cart',
        path: '/app/sales?tab=0',
        permissions: [Permission.SALES_VIEW, Permission.SALES_ADD, Permission.POS_VIEW, Permission.SHIPMENT]
      },
      {
        id: 'quotations',
        nameKey: 'Quotations',
        icon: 'fas fa-shopping-basket',
        path: '/app/quotations?tab=0',
        permissions: [Permission.QUOTATIONS_VIEW, Permission.QUOTATIONS_ADD]
      }
    ]
  },
  {
    id: 'purchases',
    nameKey: 'Purchases',
    items: [
      {
        id: 'purchases',
        nameKey: 'Purchases',
        icon: 'fas fa-receipt',
        path: '/app/purchases?tab=0',
        permissions: [Permission.PURCHASES_VIEW, Permission.PURCHASES_ADD]
      }
    ]
  },
  {
    id: 'inventory',
    nameKey: 'Inventory',
    items: [
      {
        id: 'products',
        nameKey: 'Products',
        icon: 'fas fa-book',
        path: '/app/products?tab=0',
        permissions: [Permission.PRODUCTS_ADD, Permission.PRODUCTS_VIEW, Permission.BARCODE_VIEW, Permission.BRAND, Permission.UNIT, Permission.COUNT_STOCK, Permission.CATEGORY]
      },
      {
        id: 'adjustments',
        nameKey: 'Adjustement',
        icon: 'fas fa-pen',
        path: '/app/adjustments?tab=0',
        permissions: [Permission.ADJUSTMENT_VIEW, Permission.ADJUSTMENT_ADD]
      },
      {
        id: 'transfers',
        nameKey: 'StockTransfers',
        icon: 'fas fa-arrow-left',
        path: '/app/transfers?tab=0',
        permissions: [Permission.TRANSFER_VIEW, Permission.TRANSFER_ADD]
      }
    ]
  },
  {
    id: 'accounting',
    nameKey: 'Accounting',
    items: [
      {
        id: 'accounting_dashboard',
        nameKey: 'Accounting',
        icon: 'fas fa-wallet',
        path: '/app/accounts?tab=0',
        permissions: [Permission.EXPENSE_VIEW, Permission.EXPENSE_ADD, Permission.DEPOSIT_VIEW, Permission.DEPOSIT_ADD, Permission.ACCOUNT, Permission.TRANSFER_MONEY]
      },
      {
        id: 'fixed_assets',
        nameKey: 'FixedAssets',
        icon: 'fas fa-building',
        path: '/app/fixed-assets?tab=0',
        permissions: [Permission.FIXED_ASSET_VIEW, Permission.FIXED_ASSET_ADD, Permission.FIXED_ASSET_EDIT, Permission.FIXED_ASSET_DELETE, Permission.FIXED_ASSET_CATEGORY, Permission.FIXED_ASSET_LOCATION]
      },
      {
        id: 'group_finance',
        nameKey: 'Group_Title',
        icon: 'fas fa-building',
        path: '/app/accounting/group-finance',
        permissions: [Permission.GROUP_FINANCE_VIEW]
      },
      { id: 'company_books', nameKey: 'Ledger_books', icon: 'fas fa-book', path: '/app/accounting/books', permissions: [Permission.BOOKS_VIEW] },
      { id: 'company_tax_profiles', nameKey: 'Enterprise_TaxProfiles', icon: 'fas fa-file-invoice', path: '/app/accounting/company-tax-profiles', permissions: [Permission.ACCOUNTING_SETTINGS] },
      { id: 'tax_working_paper', nameKey: 'Enterprise_TaxPaper', icon: 'fas fa-file-invoice', path: '/app/accounting/tax-working-paper', permissions: [Permission.REPORTS_FINANCIAL] },
      { id: 'issued_purchase', nameKey: 'Enterprise_Document_purchase', icon: 'fas fa-file-invoice', path: '/app/accounting/issued-purchase', permissions: [Permission.PURCHASES_VIEW] },
      { id: 'issued_sale_return', nameKey: 'Enterprise_Document_sale_return', icon: 'fas fa-file-invoice', path: '/app/accounting/issued-sale_return', permissions: [Permission.SALE_RETURNS_VIEW] },
      { id: 'issued_purchase_return', nameKey: 'Enterprise_Document_purchase_return', icon: 'fas fa-file-invoice', path: '/app/accounting/issued-purchase_return', permissions: [Permission.PURCHASE_RETURNS_VIEW] },
      { id: 'issued_sales', nameKey: 'Enterprise_IssuedSales', icon: 'fas fa-file-invoice', path: '/app/accounting/issued-sales', permissions: [Permission.SALES_VIEW] },
      { id: 'enterprise_delivery_health', nameKey: 'Enterprise_DeliveryHealth', icon: 'fas fa-heartbeat', path: '/app/accounting/delivery-health', permissions: [Permission.AUDITLOG_VIEW] },
      { id: 'intercompany', nameKey: 'Ledger_intercompany', icon: 'fas fa-building', path: '/app/accounting/intercompany', permissions: [Permission.INTERCOMPANY_VIEW] },
      {
        id: 'personal_withdrawals',
        nameKey: 'PersonalWithdrawals',
        icon: 'fas fa-hand-holding-usd',
        path: '/app/personal_withdrawals?tab=0',
        permissions: [Permission.PERSONAL_WITHDRAWAL_VIEW, Permission.CASH_WITHDRAWAL_VIEW]
      },
      {
        id: 'draft_payments',
        nameKey: 'Draft_Payments',
        icon: 'fas fa-chart-line',
        // No standalone route exists — these are tabs of the accounts page.
        path: '/app/accounts?tab=draft-payments',
        permissions: [Permission.PAYMENT_VIEW_ALL, Permission.PAYMENT_FINALIZE]
      },
      {
        id: 'draft_journals',
        nameKey: 'Draft_Journals',
        icon: 'fas fa-book',
        path: '/app/accounts?tab=draft-journals',
        // Gate on the journal permissions the SERVER enforces (DraftJournalController
        // authorizes JOURNAL_VIEWANY for the list, JOURNAL_VIEW per entry, JOURNAL_EDIT /
        // JOURNAL_FINALIZEALL on write). Payment permissions belonged to draft_payments.
        permissions: [Permission.JOURNAL_VIEWANY, Permission.JOURNAL_VIEW, Permission.JOURNAL_EDIT, Permission.JOURNAL_FINALIZEALL]
      }
    ]
  },
  {
    id: 'hrm',
    nameKey: 'HRM',
    items: [
      {
        id: 'hrm',
        nameKey: 'hrm',
        icon: 'fas fa-book',
        path: '/app/hrm?tab=0',
        permissions: [Permission.COMPANY, Permission.DEPARTMENT, Permission.DESIGNATION, Permission.OFFICE_SHIFT, Permission.VIEW_EMPLOYEE, Permission.ATTENDANCE, Permission.LEAVE, Permission.HOLIDAY, Permission.PAYROLL]
      },
      {
        id: Permission.PAYROLL,
        nameKey: 'Payroll',
        icon: 'fas fa-file-invoice-dollar',
        path: '/app/payroll',
        // F-8 — granular gating: visible with any payroll capability
        // (legacy broad `payroll` kept as fallback).
        permissions: [
          Permission.PAYROLL,
          Permission.PAYROLL_RUN_VIEW,
          Permission.PAYROLL_RUN_APPROVE,
          Permission.PAYROLL_DISBURSE,
          Permission.PAYROLL_PERIOD_VIEW,
          Permission.PAYROLL_SETTINGS_VIEW,
          Permission.PAYROLL_SENSITIVE_VIEW,
        ]
      },
      {
        id: 'my_approvals',
        nameKey: 'My_Approvals',
        icon: 'fas fa-user-check',
        path: '/app/hrm/my-approvals',
        // F-2b/F-8 — approval inbox only for potential approvers.
        permissions: [Permission.PAYROLL_RUN_APPROVE]
      }
    ]
  },
  {
    id: 'people',
    nameKey: 'People',
    items: [
      {
        id: 'people',
        nameKey: 'People',
        icon: 'fas fa-briefcase',
        path: '/app/people?tab=0',
        permissions: [Permission.CUSTOMERS_VIEW, Permission.SUPPLIERS_VIEW, Permission.USERS_VIEW]
      }
    ]
  },
  {
    id: 'reports',
    nameKey: 'Reports',
    items: [
      {
        id: 'reports',
        nameKey: 'Reports',
        icon: 'fas fa-chart-line',
        path: '/app/reports?tab=0',
        permissions: [Permission.REPORTS_PAYMENTS_SALES, Permission.REPORTS_PAYMENTS_PURCHASES, Permission.REPORTS_PAYMENTS_SALE_RETURNS, Permission.REPORTS_PAYMENTS_PURCHASE_RETURN, Permission.WAREHOUSE_REPORT, Permission.REPORTS_PROFIT, Permission.INVENTORY_VALUATION, Permission.EXPENSES_REPORT, Permission.DEPOSITS_REPORT, Permission.REPORTS_PURCHASE, Permission.REPORTS_QUANTITY_ALERTS, Permission.REPORTS_SALES, Permission.PRODUCT_SALES_REPORT, Permission.PRODUCT_PURCHASES_REPORT, Permission.REPORTS_SUPPLIERS, Permission.REPORTS_CUSTOMERS, Permission.TOP_PRODUCTS, Permission.TOP_CUSTOMERS, Permission.USERS_REPORT, Permission.PRODUCT_REPORT, Permission.STOCK_REPORT]
      }
    ]
  },
  {
    id: 'settings',
    nameKey: 'Settings',
    items: [
      {
        id: 'settings',
        nameKey: 'Settings',
        icon: 'fas fa-database',
        path: '/app/settings?tab=0',
        permissions: [Permission.SETTING_SYSTEM, Permission.SMS_SETTINGS, Permission.NOTIFICATION_TEMPLATE, Permission.POS_SETTINGS, Permission.MODULE_SETTINGS, Permission.MAIL_SETTINGS, Permission.WAREHOUSE, Permission.BACKUP, Permission.CURRENCY, Permission.PERMISSIONS_VIEW]
      },
      {
        id: 'tenant_users',
        nameKey: 'UserManagement',
        icon: 'fas fa-users',
        path: '/app/settings/tenant/users',
        permissions: [Permission.USERS_VIEW]
      },
      {
        id: 'bot_gateway',
        nameKey: 'WhatsAppTelegram',
        icon: 'fas fa-comments',
        path: '/app/bot-gateway',
        permissions: [Permission.BOT_CHANNELS_MANAGE, Permission.BOT_LIVE_CHAT_USE, Permission.BOT_TEMPLATES_MANAGE, Permission.BOT_AUTO_REPLIES_MANAGE]
      }
    ]
  },
  {
    id: 'others',
    nameKey: 'Others',
    items: [
      {
        id: 'files',
        nameKey: 'Files',
        icon: 'fas fa-folder',
        path: '/app/files',
        // Mirrors the App.tsx route guard: an item with no `permissions`
        // array renders for every authenticated user, which advertised a page
        // the route guard then refused. The server still enforces the gate.
        permissions: [Permission.SETTING_SYSTEM]
      },
      {
        id: 'opening_inventory',
        nameKey: 'OpeningInventory',
        icon: 'fas fa-box-open',
        path: '/app/opening_inventory',
        permissions: [Permission.SETUP_OPENING_INVENTORY]
      }
    ]
  }
];

export function hasPermission(userPermissions: string[] | undefined | null, itemPermissions: string[] | undefined): boolean {
  // Empty/absent requirements mean "no gate" (menu-filtering semantics) — which
  // is why every item that maps to a RouteGuard must list its permission here.
  // Callers that need fail-closed behaviour guard the length themselves
  // (see hooks/usePermission.ts canAny/canAll).
  if (!itemPermissions || itemPermissions.length === 0) return true;
  if (!userPermissions) return false;
  return itemPermissions.some(p => userPermissions.includes(p));
}
